/* eslint-disable import/no-extraneous-dependencies */
import { FC, useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars'
import CN from 'classnames'
import { AnimatePresence, motion } from 'framer-motion'
import {
  useGetPWBulkConsignmentHistory,
  useGetWarehouseById,
  useICSBulkOrderConsign,
  usePWBulkOrderConsign,
  useUserList,
} from 'framework/api/methods'
import useGetICSBulkConsignmentHistory from 'framework/api/methods/ICSBulkConsignment/useGetICSBulkConsignmentHistory'
import useGetPartnerListByIntegration from 'framework/api/methods/partner/useGetPartnerListByIntegration'
import useGetBulkConsignmentUsers from 'framework/api/methods/PWbulkConsignment/useGetBulkConsignmentUsers'
import { addWebSocketEventListener } from 'framework/websocket/ws'

import {
  Button,
  ICSBulkConsignment,
  Input,
  JsonLoader,
  PWBulkConsignment,
  SimpleSelect,
} from 'components/atoms'
import { DataTable as BulkHistoryTable } from 'components/pages/BulkOrderConsignmentNew/Common/Tables/BulkSummaryDataTable'

export interface BulkConsignmentHistoryProps {
  [x: string]: any
}

export const BulkConsignmentHistory: FC<BulkConsignmentHistoryProps> = ({
  className,
  isActive,
  onCloseClick,
  notify,
  setHistoryIsOpen,
  seBulkConsignmentMenuIsOpen,
  setPWBulkConsignmentIsOpen,
  setSummaryIsOpen,
  setSummaryData,
  FromHistory,
  setFromHistory,
  setWarehouseDetails,
  userDetails,
  integrationType,
  setIntegrationType,
}: BulkConsignmentHistoryProps) => {
  const [isFilterMenuOpen, setIsFilterModalOpen] = useState(true)

  const sydneyTime = new Date().toLocaleString('en-US', {
    timeZone: 'Australia/Sydney',
  })
  const nowSydney = new Date(sydneyTime)

  // Get start of the day (00:00:00) and end of the day (23:59:59)
  const startOfDaySydney = new Date(
    nowSydney.getFullYear(),
    nowSydney.getMonth(),
    nowSydney.getDate(),
    0,
    0,
    0,
  )
  const endOfDaySydney = new Date(
    nowSydney.getFullYear(),
    nowSydney.getMonth(),
    nowSydney.getDate(),
    0,
    0,
    0,
  )
  const [filterVariables, setFilterVariables] = useState<any>({
    principle: { label: 'Signal Brands', value: '42167' },
    consNo: '',
    consignedFrom: startOfDaySydney,
    consignedTo: endOfDaySydney,
    createdFrom: '',
    createdTo: '',
    user: { label: 'All', value: '' },
    bulkSlipNo: '',
  })
  const [filterActive, setFilterActive] = useState(false)
  const [mainLoadingState, setIsLoading] = useState(false)

  const [historyList, setHistoryList] = useState([])
  const [totalRowCount, setTotalRowCount] = useState(0)

  const [userList, setUserList] = useState([])

  const [warehouseId, setWarehouseId] = useState<any>()
  const [progressDetails, setProgress] = useState([
    {
      splitReferance: '',
      progress: 0,
    },
  ])

  const [value, setValue] = useState(0)
  const [userListvariables, setUserListvariables] = useState({
    skip: null,
    take: null,
    Search: null,
  })

  const theme = createTheme({
    palette: {
      primary: {
        main: '#F1A248', // green for selected sub-tabs
      },
      secondary: {
        main: '#F1A248', // orange for selected main-tabs
      },
    },
  })

  const [mainTabValue, setMainTabValue] = useState(0) // 0 = Paperless, 1 = ICS
  const [statusTabValue, setStatusTabValue] = useState(0) // 0 = Drafts, 1 = InProgress, 2 = Completed, 3 = Failed

  const statusMap = ['Pending', 'InProgress', 'Completed', 'Failed']
  const [status, setStatus] = useState(statusMap[statusTabValue])

  const [tableVariables, setTableVariables] = useState({
    take: 10,
    skip: 0,
    search: '',
  })
  const [pageNumber, setPageNumber] = useState(1)

  const [partnerList, setPartnerList] = useState([])
  const [bulkReferance, setbulkReferance] = useState()

  const handleTabChange = async (
    event: React.SyntheticEvent,
    newValue: number,
  ) => {
    if (newValue === 0) {
      await getPartnerListByIntegration('PaperlessWms')
      await setFilterVariables({
        principle: { label: 'Signal Brands', value: '42167' },
        consNo: '',
        consignedFrom: '',
        consignedTo: '',
        createdFrom: '',
        createdTo: '',
        user: { label: 'All', value: '' },
        bulkSlipNo: '',
      })
      setIntegrationType('Paperless')
      setMainTabValue(newValue)
      setStatusTabValue(0)
      setPageNumber(1)
      // Fetch data for Paperless tab
      getPWBulkConsignmentHistoryList()
    }

    if (newValue === 1) {
      await getPartnerListByIntegration('ICSWms')
      await setFilterVariables({
        principle: { label: 'Universal Music Group', value: 'UM' },
        consNo: '',
        consignedFrom: '',
        consignedTo: '',
        createdFrom: '',
        createdTo: '',
        user: { label: 'All', value: '' },
        bulkSlipNo: '',
      })
      setIntegrationType('ICSWms')
      setMainTabValue(newValue)
      setStatusTabValue(0)
      setPageNumber(1)
      // Fetch data for Paperless tab
      getICSBulkConsignmentHistoryList()
    }
    setStatusTabValue(0) // Reset to Drafts
    setPageNumber(1)
  }

  const handleStatusTabChange = (
    event: React.SyntheticEvent,
    newValue: number,
  ) => {
    setStatusTabValue(newValue)
  }

  useEffect(() => {
    setStatus(statusMap[statusTabValue])
    setPageNumber(1)
  }, [statusTabValue, mainTabValue])

  useEffect(() => {
    if (mainTabValue === 0) {
      getPWBulkConsignmentHistoryList()
    }
    if (mainTabValue === 1) {
      getICSBulkConsignmentHistoryList()
    }
  }, [
    tableVariables.skip,
    tableVariables.take,
    tableVariables.search,
    status,
    bulkReferance,
  ])

  /** API Call for Bulk Order Consign */
  const {
    mutate: pwbulkOrderConsignMutate,
    isLoading: pwbulkOrderConsignIsLoading,
  } = usePWBulkOrderConsign()

  /** Process the Bulk Order Consign */
  async function createPwShipmentConsignment(
    splitReferance: string,
  ): Promise<void> {
    pwbulkOrderConsignMutate(
      {
        serviceSplitReference: splitReferance,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          notify(successData.message || 'success', 'success')
        },
        onError: ({ response: { data: errData } }: any) => {
          notify(errData.message || 'Error...!', 'error')
        },
      },
    )
  }

  /** API Call for ICS Bulk Order Consign */
  const {
    mutate: icsbulkOrderConsignMutate,
    isLoading: icsbulkOrderConsignIsLoading,
  } = useICSBulkOrderConsign()

  /** Process the ICS  Bulk Order Consign */
  async function createICSShipmentConsignment(
    splitReferance: string,
  ): Promise<void> {
    icsbulkOrderConsignMutate(
      {
        splitReference: splitReferance,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          notify(successData.message || 'success', 'success')
          addWebSocketEventListener('progress', (message: any) => {
            // Log the entire WebSocket message to verify its structure
            console.log('📩 WebSocket message received:', message)
            if (typeof message === 'string') {
              message = JSON.parse(message)
            }

            // Destructure progress and splitReferance from the message
            const { progress: newProgress, splitReferance } = message

            // Check if progress and splitReferance are not undefined
            if (newProgress !== undefined && splitReferance !== undefined) {
              // Update the progress state for the specific splitReferance
              setProgress((prev) => ({
                ...prev,
                [splitReferance]: newProgress, // Use splitReferance as the key and progress as the value
              }))
            }
          })
        },
        onError: ({ response: { data: errData } }: any) => {
          notify(errData.message || 'Error...!', 'error')
        },
      },
    )
  }

  /** API Call for get partner list function using react-query */
  const {
    mutate: GetPartnerOrderListByIntegrationMutate,
    isLoading: getPartnerTableIsLoading,
  } = useGetPartnerListByIntegration()

  /** Process to get partner List for integration */
  async function getPartnerListByIntegration(
    integration: string,
  ): Promise<void> {
    GetPartnerOrderListByIntegrationMutate(
      { warehuseIntegration: integration },
      {
        onSuccess: ({ data: successData }: any) => {
          const result: any = []
          successData.partners.forEach((item: any) => {
            if (item.isActive) {
              result.push({ label: item.name, value: item?.code, id: item?.id })
            }
          })
          setPartnerList(result)
        },
        onError: ({ response: { data: errData } }: any) => {
          notify(errData.message || 'Error', 'error')
        },
      },
    )
  }

  /** API Call for Get History List */
  const {
    mutate: getPWBulkConsignmentHistoryListMutate,
    //isLoading: getPWBulkConsignmentHistoryListIsLoading,
  } = useGetPWBulkConsignmentHistory()

  /** Process the Get Similar Order List */
  async function getPWBulkConsignmentHistoryList() {
    setIsLoading(true)
    getPWBulkConsignmentHistoryListMutate(
      {
        take: tableVariables.take,
        skip: tableVariables.skip,
        status,
        bulkReferance,
        filterVariables,
        splitReferance: '',
      },
      {
        onSuccess: ({ data: successData }: any) => {
          setHistoryList(successData?.summaryList)
          setTotalRowCount(successData?.totalCount)
          if (bulkReferance) {
            setSummaryData(successData?.summaryList)
            setSummaryIsOpen(true)
            setHistoryIsOpen(false)
          }
          if (status == 'InProgress') {
            addWebSocketEventListener('progress', (message: any) => {
              // Log the entire WebSocket message to verify its structure
              console.log('📩 WebSocket message received:', message)
              if (typeof message === 'string') {
                message = JSON.parse(message)
              }

              // Destructure progress and splitReferance from the message
              const { progress: newProgress, splitReferance } = message

              // Check if progress and splitReferance are not undefined
              if (newProgress !== undefined && splitReferance !== undefined) {
                // Update the progress state for the specific splitReferance
                setProgress((prev) => ({
                  ...prev,
                  [splitReferance]: newProgress, // Use splitReferance as the key and progress as the value
                }))
              }
            })
          }
          setIsLoading(false)
        },
        onError: ({ response: { data: errData } }: any) => {
          notify(errData.message || 'Error...!', 'error')
          setIsLoading(false)
        },
      },
    )
  }

  const {
    mutate: getPWBulkConsignmetUsersMutate,
    //isLoading: getPWBulkConsignmentHistoryListIsLoading,
  } = useGetBulkConsignmentUsers()

  async function getPWBulkConsignmentUsers() {
    try {
      setIsLoading(true)

      getPWBulkConsignmetUsersMutate(undefined, {
        onSuccess: (successData: any) => {
          const result =
            successData?.data?.userProfiles?.map((item: any) => ({
              label: `${item.firstName} ${item.lastName}`,
              value: item?.userName,
            })) || []

          setUserList(result)
        },
        onError: (error: any) => {
          const message =
            error?.response?.data?.message || 'Something went wrong.'
          notify(message, 'error')
          setIsLoading(false)
        },
      })
    } catch (err) {
      notify('An unexpected error occurred.', 'error')
      setIsLoading(false)
    }
  }

  /** API Call for Get ICS History List */
  const {
    mutate: getICSBulkConsignmentHistoryListMutate,
    //isLoading: getICSBulkConsignmentHistoryListIsLoading,
  } = useGetICSBulkConsignmentHistory()

  /** Process the Get Similar Order List */
  async function getICSBulkConsignmentHistoryList() {
    setIsLoading(true)
    getICSBulkConsignmentHistoryListMutate(
      {
        take: tableVariables.take,
        skip: tableVariables.skip,
        status,
        bulkReferance,
        filterVariables,
        splitReferance: '',
      },
      {
        onSuccess: ({ data: successData }: any) => {
          setHistoryList(successData?.icsSummaryList)
          setTotalRowCount(successData?.totalCount)
          if (bulkReferance) {
            setSummaryData(successData?.icsSummaryList)
            setSummaryIsOpen(true)
            setHistoryIsOpen(false)
          }
          if (status == 'InProgress') {
            addWebSocketEventListener('progress', (message: any) => {
              // Log the entire WebSocket message to verify its structure
              console.log('📩 WebSocket message received:', message)
              if (typeof message === 'string') {
                message = JSON.parse(message)
              }

              // Destructure progress and splitReferance from the message
              const { progress: newProgress, splitReferance } = message

              // Check if progress and splitReferance are not undefined
              if (newProgress !== undefined && splitReferance !== undefined) {
                // Update the progress state for the specific splitReferance
                setProgress((prev) => ({
                  ...prev,
                  [splitReferance]: newProgress, // Use splitReferance as the key and progress as the value
                }))
              }
            })
          }
          setIsLoading(false)
        },
        onError: ({ response: { data: errData } }: any) => {
          notify(errData.message || 'Error...!', 'error')
          setIsLoading(false)
        },
      },
    )
  }

  useEffect(() => {
    setIsLoading(true)
    if (mainTabValue === 0) {
      setIntegrationType('Paperless')
      getPartnerListByIntegration('PaperlessWms')
      getPWBulkConsignmentUsers()
      getPWBulkConsignmentHistoryList()
    }
    if (mainTabValue === 1) {
      getPartnerListByIntegration('ICSWms')
      getICSBulkConsignmentHistoryList()
    }
  }, [])

  const [retryFailed, setRetryFailed] = useState({
    isRetry: false,
    serviceSplitReference: '',
  })

  function FormatDate(dateString: string) {
    const dateObject = new Date(dateString)
    const year = dateObject.getFullYear()
    const month = dateObject.getMonth() + 1 // getMonth() returns month index (0-11), so add 1 for the actual month
    const day = dateObject.getDate()
    const formattedDate = `${year}/${month.toString().padStart(2, '0')}/${day
      .toString()
      .padStart(2, '0')}`
    return formattedDate
  }

  const customizeClass = CN(
    'w-[350px] px-6 py-4 text-lg font-semibold text-white rounded-lg hover:bg-blue-700 flex items-start justify-start',
  )
  return (
    <div
      className={CN(
        'flex items-start justify-center bg-white h-full w-full pt-4 px-8 pb-0',
        {},
        className,
      )}>
      {/* Loading Screen */}
      {mainLoadingState && (
        <div className='flex w-full h-full items-center justify-center bg-N-800 absolute z-[99] left-0 top-0 bg-opacity-20 cursor-not-allowed'>
          <JsonLoader size='xs' />
        </div>
      )}

      <div className='flex flex-col w-full h-full bg-white overflow-y-auto styled-scroll'>
        <div className='flex flex-col w-full h-auto bg-white rounded-lg px-4 py-2 pb-8'>
          <Button
            className='mb-1'
            size='xs'
            appearance='outline'
            onClick={() => {
              seBulkConsignmentMenuIsOpen(true)
              setPWBulkConsignmentIsOpen(false)
              setHistoryIsOpen(false)
            }}>
            <i className='ri-arrow-left-line pr-3'></i> Back to bulk order
            consignment
          </Button>
          <div className='flex w-full items-center justify-between pt-6'></div>
          <div className='flex flex-col w-full h-auto bg-white rounded-lg px-0 py-2 pb-8'>
            <ThemeProvider theme={theme}>
              <Box sx={{ width: '80%' }}>
                <div className='flex flex-col w-full h-auto bg-white rounded-lg  py-2 pb-8'>
                  <AppBar
                    position='static'
                    sx={{ bgcolor: 'transparent', boxShadow: 'none' }}>
                    <Tabs
                      value={mainTabValue}
                      onChange={handleTabChange}
                      indicatorColor='secondary'
                      textColor='inherit'
                      variant='standard'
                      aria-label='main tabs'>
                      <Tab
                        label='Paperless WMS'
                        sx={{
                          'minWidth': 250,
                          'px': 0,
                          'backgroundColor':
                            mainTabValue === 0 ? '#F1A248' : '#E0E0E0',
                          'color': '#fff',
                          'fontWeight': 400,
                          'fontSize': 18,
                          'borderRadius': 0,
                          'mx': 0,
                          '&:hover': {
                            backgroundColor:
                              mainTabValue === 0 ? '#F1A248' : '#bdbdbd',
                          },
                          'transition': 'background 0.2s',
                        }}
                      />
                      <Tab
                        label='ICS WMS'
                        sx={{
                          'minWidth': 250,
                          'px': 0,
                          'backgroundColor':
                            mainTabValue === 1 ? '#F1A248' : '#E0E0E0',
                          'color': '#fff',
                          'fontWeight': 400,
                          'fontSize': 18,
                          'borderRadius': 0,
                          'mx': 0,
                          '&:hover': {
                            backgroundColor:
                              mainTabValue === 1 ? '#F1A248' : '#bdbdbd',
                          },
                          'transition': 'background 0.2s',
                        }}
                      />
                    </Tabs>
                  </AppBar>
                </div>
                <Button
                  onClick={() => {
                    setIsFilterModalOpen(!isFilterMenuOpen)
                  }}
                  appearance={isFilterMenuOpen ? 'default' : 'outline'}>
                  <i className='ri-filter-3-line pr-3'></i> Filter
                </Button>
                {filterActive && (
                  <div className='w-[6px] h-[2px] bg-R-500 rounded-full absolute top-[0px] right-[-2px]'></div>
                )}

                <AnimatePresence initial={false}>
                  {isFilterMenuOpen && (
                    <motion.div
                      className='flex flex-col bg-white w-full'
                      initial='collapsed'
                      animate='open'
                      exit='collapsed'
                      transition={{ type: 'tween', duration: 0.3 }}
                      variants={{
                        open: { opacity: 1, y: 0, height: 'auto' },
                        collapsed: { opacity: -1, y: -35, height: 0 },
                      }}>
                      <div className='flex flex-col w-full mb-4 py-2 z-50'>
                        <div className='flex flex-row w-full gap-x-5'>
                          <div className='flex flex-col w-1/6 z-[50]'>
                            <span className='pb-1 text-N-700'>Principle</span>
                            <SimpleSelect
                              value={filterVariables.principle}
                              options={[
                                { label: 'All', value: '' },
                                ...partnerList,
                              ]}
                              onChange={(e: any) => {
                                setFilterVariables({
                                  ...filterVariables,
                                  principle: {
                                    label: e.label,
                                    value: e.value,
                                  },
                                })
                              }}
                            />
                          </div>

                          {mainTabValue === 0 && (
                            <>
                              <div className='flex flex-col w-1/6 z-[50]'>
                                <span className='pb-1 text-N-700'>Cons No</span>
                                <Input
                                  value={filterVariables?.consNo || ''} // Ensure it's not undefined
                                  onChange={(e: any) => {
                                    setFilterVariables((_prev: any) => ({
                                      ...filterVariables,
                                      consNo: e.target.value, // Get the correct value from the input
                                    }))
                                  }}
                                />
                              </div>
                            </>
                          )}
                          {mainTabValue === 1 && (
                            <>
                              <div className='flex flex-col w-1/6 z-[50]'>
                                <span className='pb-1 text-N-700'>
                                  Bulk Slip No
                                </span>
                                <Input
                                  value={filterVariables?.bulkSlipNo || ''} // Ensure it's not undefined
                                  onChange={(e: any) => {
                                    setFilterVariables((_prev: any) => ({
                                      ...filterVariables,
                                      bulkSlipNo: e.target.value, // Get the correct value from the input
                                    }))
                                  }}
                                />
                              </div>
                            </>
                          )}
                          <div className='flex flex-col w-1/6 z-[50]'>
                            <span className='pb-1 text-N-700'>User</span>
                            <SimpleSelect
                              value={filterVariables.user}
                              options={[
                                { label: 'All', value: '' },
                                ...userList,
                              ]}
                              onChange={(e: any) => {
                                setFilterVariables({
                                  ...filterVariables,
                                  user: {
                                    label: e.label,
                                    value: e.value,
                                  },
                                })
                              }}
                            />
                          </div>

                          {status !== 'Completed' && (
                            <div className='flex flex-col w-1/6 z-[50]'>
                              <span className='pb-1 text-N-700'>
                                Created Date
                              </span>
                              <div className='date-picker mt-0'>
                                <DateRangePickerComponent
                                  format='yyyy/MM/dd'
                                  delayUpdate={true}
                                  placeholder='Select a range'
                                  onChange={(e: any) => {
                                    setFilterVariables({
                                      ...filterVariables,
                                      createdFrom: FormatDate(
                                        e.target.startDate,
                                      ),
                                      createdTo: FormatDate(e.target.endDate),
                                    })
                                  }}
                                  startDate={filterVariables?.createdFrom}
                                  endDate={filterVariables?.createdTo}
                                />
                              </div>
                            </div>
                          )}

                          {status === 'Completed' && (
                            <div className='flex flex-col w-1/6 z-[50]'>
                              <span className='pb-1 text-N-700'>
                                Consigned Date
                              </span>
                              <div className='date-picker mt-0'>
                                <DateRangePickerComponent
                                  format='yyyy/MM/dd'
                                  delayUpdate={true}
                                  placeholder='Select a range'
                                  onChange={(e: any) => {
                                    setFilterVariables({
                                      ...filterVariables,
                                      consignedFrom: FormatDate(
                                        e.target.startDate,
                                      ),
                                      consignedTo: FormatDate(e.target.endDate),
                                    })
                                  }}
                                  startDate={filterVariables?.consignedFrom}
                                  endDate={filterVariables?.consignedTo}
                                />
                              </div>
                            </div>
                          )}

                          <div className='flex items-end gap-3 w-1/6 z-[50] '>
                            <Button
                              onClick={() => {
                                filterVariables.principle.value === ''
                                  ? setFilterActive(false)
                                  : setFilterActive(true)

                                if (mainTabValue === 0) {
                                  getPWBulkConsignmentHistoryList()
                                }
                                if (mainTabValue === 1) {
                                  getICSBulkConsignmentHistoryList()
                                }
                                setPageNumber(1)
                              }}>
                              Apply
                            </Button>
                            <Button
                              appearance='dull'
                              onClick={() => {
                                if (mainTabValue === 0) {
                                  setFilterVariables({
                                    principle: {
                                      label: 'Signal Brands',
                                      value: '42167',
                                    },
                                    consNo: '',
                                    user: { label: 'All', value: '' },
                                    createdFrom: '',
                                    createddTo: '',
                                    consignedFrom: '',
                                    consignedTo: '',
                                    bulkReferance: '',
                                  })
                                }
                                if (mainTabValue === 1) {
                                  setFilterVariables({
                                    principle: {
                                      label: 'Universal Music Group',
                                      value: 'UM',
                                    },
                                    consNo: '',
                                    user: { label: 'All', value: '' },
                                    createdFrom: '',
                                    createddTo: '',
                                    consignedFrom: '',
                                    consignedTo: '',
                                    bulkSlipNo: '',
                                  })
                                }
                                setPageNumber(1)
                              }}>
                              Clear
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className='flex flex-row w-full mb-2 py-2 z-30'></div>
                    </motion.div>
                  )}
                </AnimatePresence>
                <div className='flex flex-col w-full h-auto bg-white rounded-lg  py-6 pb-8'>
                  <Box sx={{ width: '70%' }}>
                    <AppBar position='static' color='default'>
                      <Tabs
                        value={statusTabValue}
                        onChange={handleStatusTabChange}
                        indicatorColor='primary'
                        textColor='primary'
                        variant='standard'>
                        <Tab label='Drafts' sx={{ minWidth: 200, px: 1 }} />
                        <Tab
                          label='In Progress'
                          sx={{ minWidth: 200, px: 1 }}
                        />
                        <Tab label='Completed' sx={{ minWidth: 200, px: 1 }} />
                        <Tab label='Failed' sx={{ minWidth: 200, px: 1 }} />
                      </Tabs>
                    </AppBar>
                  </Box>
                </div>
                {/* Tab Content */}
              </Box>
            </ThemeProvider>
            <div className='flex flex-col w-full h-auto bg-white rounded-lg px-0 py-0 overflow: visible'>
              <BulkHistoryTable
                itemData={historyList}
                className=''
                setTableVariables={setTableVariables}
                tableVariables={tableVariables}
                totalRowCount={totalRowCount}
                setIsLoading={false}
                setPageNumber={setPageNumber}
                pageNumber={pageNumber}
                status={status}
                setbulkreferance={setbulkReferance}
                FromHistory={true}
                setFromHistory={setFromHistory}
                setWarehouseId={setWarehouseId}
                setWarehouseDetails={setWarehouseDetails}
                createPwShipmentConsignment={createPwShipmentConsignment}
                createICSShipmentConsignment={createICSShipmentConsignment}
                progressDetails={progressDetails}
                setStatus={setStatus}
                setSummaryData={setSummaryData}
                userDetails={userDetails}
                integrationType={integrationType}
                isSummary={false}
                setRetryFailed={setRetryFailed}
              />
            </div>
            <div className='flex flex-col w-full items-center justify-between pt-12'></div>
          </div>
        </div>
      </div>
    </div>
  )
}

BulkConsignmentHistory.defaultProps = {}

export default BulkConsignmentHistory
